module.exports = __webpack_public_path__ + "static/img/zhcg82.37e2c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhcg82.png
// module id = 39TS
// module chunks = 73